'use client';
import { Row } from '@/ui/primatives';
import Tag from '@/ui/Tag';

import { IRepository } from '@/types';

import { IEvaluation } from '@/lib/evaluationsApi';
import BreadCrumbs from '@/components/BreadCrumbsGeneric';
import { RocketIcon } from '@radix-ui/react-icons';
import Button from '@/ui/Button';

const EvaluationHeader = ({
  repository,
  evaluation,
  iterations,
  sectionNavigationPath,
}: {
  repository: IRepository;
  evaluation: IEvaluation;
  iterations: number;
  sectionNavigationPath: string;
}) => {
  return (
    <Row alignItems="center" justifyContent="space-between">
      <div>
        <BreadCrumbs
          items={[
            { name: 'Evaluations', href: `/${repository!.namespace}/${repository!.name}/${sectionNavigationPath}` },
            {
              name: evaluation.name || evaluation.id,
              href: `/${repository!.namespace}/${repository!.name}/${sectionNavigationPath}/${evaluation.id}`,
            },
          ]}
          icon={<RocketIcon />}
          style={{ flex: 0 }}
        />
      </div>
      <Button.Text
        small
        href={`/${repository!.namespace}/${repository!.name}/${sectionNavigationPath}/${evaluation.master_id}/history`}
      >
        History{' '}
        {iterations > 1 && (
          <Tag variant="default" pill small className="counter-tag" data-tutorialid="evaluation-history-link">
            {iterations}
          </Tag>
        )}
      </Button.Text>
    </Row>
  );
};

export default EvaluationHeader;
